import { statsContract } from '@bibleawr/landing2-contract'
import { createLandingTsRestClient } from '~/infrastructure/api/ts-rest-client'

export function useAboutStats() {
  const client = createLandingTsRestClient(statsContract)

  const { data } = useAsyncData('about-stats', async () => {
    const response = await client.getAboutStats()
    if (response.status !== 200) return null
    // ResponseWrapInterceptor wraps body in { data, success }
    return (response.body as { data: AboutStats })?.data ?? null
  })

  return { data }
}
